import { Component, HostListener, OnInit } from '@angular/core';
import { SafeGoService } from './safe-go.service';
import { SafeGo } from './../models/sale';
import { AuthService } from 'src/app/auth.service';
import { NotificationService } from '../shared/notification.service';

@Component({
  selector: 'app-safe-go',
  templateUrl: './safe-go.component.html',
  styleUrls: ['./safe-go.component.less']
})
export class SafeGoComponent implements OnInit {
  tabIndex: number = 0;
  tabIndexList: {index: number, title: string}[] = [
    {index: 0, title: 'Open'},
    {index: 1, title: 'Completed'}
  ];
  safeGoTable: SafeGo[] = [];
  isLoading: boolean = false;
  verifySafeGoModal: boolean = false;
  safeGoPin: number | null = null;
  selectedSafeGoItem: SafeGo = new SafeGo();
  isVerificationRemover: boolean = false;
  isAllChecked: boolean = false;
  pageSize = 20;

  filterDate = [
    { text: '', value: '' },
  ];

  inputValue: string = '';
  selectedOrderDateRange: Date[] = [];

  @HostListener("window:scroll", [])
    onScroll(): void {
    if ((window.innerHeight + window.scrollY) >= document.body.scrollHeight - (document.body.scrollHeight * 0.1)) {
            // you're at the bottom of the page
            this.pageSize += 15;
            this.inputValue = this.inputValue;
        }
    }
    resetTable(inputValue: string) {
      if(this.inputValue !== inputValue) 
        this.pageSize = 20;
      this.inputValue = inputValue;

    }

  constructor(private safeGoService: SafeGoService, private authService: AuthService, private notificationService: NotificationService) { }

  ngOnInit(): void {
    this.isLoading = true;
    this.safeGoService.getSafeGo().subscribe((data: SafeGo[]) => {
      this.safeGoTable = data || [];
      this.isLoading = false;
    }, error => {
      console.error('Error fetching SafeGo data:', error);
      this.isLoading = false;
    });
  }

  filterSafeGoList(statusId: number): SafeGo[] {
    // safeGoStatus is when the full safeGo cycle is completed and the row item can be moved to be completed
    let filteredList: SafeGo[];

    if(statusId !== 1)
      filteredList = this.safeGoTable.filter(item => item.safeGoStatus === 0 || item.safeGoStatus === 1);
    else
      filteredList = this.safeGoTable.filter(item => item.safeGoStatus === 2 || item.safeGoStatus === 3);

    if (this.selectedOrderDateRange.length === 2) {
      const rangeStart = new Date(this.selectedOrderDateRange[0]);
      rangeStart.setHours(0, 0, 0, 0);
      const rangeEnd = new Date(this.selectedOrderDateRange[1]);
      rangeEnd.setHours(23, 59, 59, 999);

      filteredList = filteredList.filter(item => {
        const orderDate = new Date(item.date + 'Z');
        return !isNaN(orderDate.getTime()) && orderDate >= rangeStart && orderDate <= rangeEnd;
      });
    }

    return filteredList;

  }

  sendSafeGoWhatsApp(item: SafeGo): void {
    this.safeGoService.sendSafeGoWhatsApp(item.orderId, item.safeGoStatus).subscribe(
      (response: any) => {
        this.selectedSafeGoItem = new SafeGo();
        this.selectedSafeGoItem = item;
        this.selectedSafeGoItem.safeGoStatus = response;
      },
      (error: any) => {
        console.error('Error during SafeGo verification:', error);
        this.notificationService.showError('An error occurred during SafeGo verification. Please try again later.');
      }
    )
  }

  openSafeGoModal(item: SafeGo): void {
    this.verifySafeGoModal = true;
    this.selectedSafeGoItem = new SafeGo();
    this.selectedSafeGoItem = item;
  }

  verifySafeGo(item: SafeGo, safeGoPin: number | null): void {
    if (!safeGoPin) {
      this.notificationService.showError('SafeGo PIN is required for verification.');
      return;
    }
    if (item.safeGoPin !== safeGoPin) {
      this.notificationService.showError('Invalid SafeGo PIN provided.');
      return;
    }

    this.safeGoService.verifySafeGo(item.orderId, safeGoPin).subscribe(
      (response: any) => {
        if (response === 200) {
          this.notificationService.showSuccess('SafeGo verification successful.');
          item.safeGoStatus = 2;
          this.verifySafeGoModal = false;
          this.safeGoPin = null;
        } else {
          this.notificationService.showError('SafeGo verification failed. Please try again.');
        }
      },
      (error: any) => {
        console.error('Error during SafeGo verification:', error);
        this.notificationService.showError('An error occurred during SafeGo verification. Please try again later.');
      }
    );
    
  }
  onAllCheckedChange(event: boolean): void {
    this.safeGoTable.filter(item => item.safeGoStatus <= 1).forEach((num, index) => {
      this.safeGoTable[index].removePinVerification = event;
    });
    this.safeGoTable.slice();
  }

  indeterminate(){
    let trueValue = (!this.safeGoTable.filter(item => item.safeGoStatus <= 1).every(obj => obj.removePinVerification === true) && this.safeGoTable.filter(item => item.safeGoStatus <= 1 && item .removePinVerification === true).length > 0);
    return trueValue
  }
  allChecked(){
    if(this.safeGoTable.filter(item => item.safeGoStatus <= 1).every(obj => obj.removePinVerification === true))
      return true;
    else if (this.safeGoTable.filter(item => item.safeGoStatus <= 1).every(obj => obj.removePinVerification === false))
      return false;
  return false
  }

  removePinVerification(){
    
    // .forEach(val => val.safeGoStatus = 3);
    this.safeGoService.removeUnverifiedSafeGo(this.safeGoTable.filter(item => item.safeGoStatus <= 1 && item.removePinVerification === true)).subscribe(
      (response: any) => {
        if (response === 200) {
          this.notificationService.showSuccess('SafeGo verification removed successful.');
          this.safeGoTable = this.safeGoTable.filter(item => item.safeGoStatus <= 1 && item.removePinVerification !== true)
        } else {
          this.notificationService.showError('SafeGo verification removal failed. Please try again.');
        }
      },
      (error: any) => {
        console.error('Error during SafeGo verification removal:', error);
        this.notificationService.showError('An error occurred during SafeGo verification removal. Please try again later.');
      }
    );
  }
}

